import React from 'react';
import { StyledCenteredP, StyledColorResultsDiv } from '../../style/style';
import { Color as ModelsColor } from '../../services/staticDataService';
import ColorResults from './ColorResults';

interface ResultsProps {
  choice: string;
  color: ModelsColor;
  percentControversial: number;
}

function JudgementResult(props: ResultsProps) {
  const { choice, color, percentControversial } = props;

  return (
    <StyledColorResultsDiv>
      <StyledCenteredP>{`you said: ${choice}`}</StyledCenteredP>
      <ColorResults color={color} />
      <StyledCenteredP>
        you've been {percentControversial}% controversial
      </StyledCenteredP>
    </StyledColorResultsDiv>
  );
}

export default JudgementResult;
